<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.货架详情编辑") }}</span>
    </div>
    <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button size="medium" round @click.native="goBack">
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isEditMode && !isInit">
            <el-button size="medium" round @click="modify">
              <i class="iconfont">&#xe618;</i>
              {{ $t("message.修改") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.保存") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isInit">
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont">&#xe667;</i>
              {{ $t("message.刷新") }}
            </el-button>
          </el-link>
        </div>
      </div>
    </div>
    <div class="grid-content subtitle">
      <span>1.货架主信息</span>
    </div>
    <div class="grid-content content-margin">
      <el-divider></el-divider>
      <table class="simpleRow">
        <tr v-if="shelvesid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.货架ID") }}</span>
          </td>
          <td>
            <el-input v-model="shelvesid" readonly size="mini" placeholder="">
              <!-- <template slot="prepend">详情类型ID</template> -->
            </el-input>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.货架名称1") }}</span>
          </td>
          <td>
            <el-input
              :readonly="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="name"
              type="textarea"
              :placeholder="$t('message.请输入货架名称')"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.货架名称2") }}</span>
          </td>
          <td>
            <el-input
              :readonly="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="name2"
              type="textarea"
              :placeholder="$t('message.请输入货架名称')"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>
        <tr>
          <td style="padding-left: 20px">
            <span class="simpleLabel">{{ $t("message.品牌") }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="brandid"
              :placeholder="$t('message.请选择')"
              clearable
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.货架主图") }}</span>
          </td>
          <td>
            <!-- 图片库控件 -->
            <div
              :class="!isEditMode ? 'unsel-img-box' : 'sel-img-box'"
              @click="doShowResourceStore(1)"
            >
              <i class="iconfont" v-if="!img">&#xe727;</i>
              <el-popover placement="right" trigger="hover" v-else>
                <img
                  :src="img"
                  alt=""
                  style="max-width: 500px; max-height: 500px"
                />
                <img slot="reference" :src="img" />
                <el-button
                  v-if="isEditMode"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click.native="img = ''"
                ></el-button>
              </el-popover>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.货架描述") }}</span>
          </td>
          <td>
            <el-input
              :readonly="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="shelvesinfo"
              type="textarea"
              :placeholder="$t('message.请输入货架描述')"
              maxlength="2000"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.跳转链接") }}</span>
          </td>
          <td>
            <el-input
              :readonly="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="jumpurl"
              type="textarea"
              :placeholder="$t('message.请输入链接')"
              maxlength="2000"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.货架状态") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="state">
              <el-radio :label="0">{{ $t("message.正常") }}</el-radio>
              <el-radio :label="1">{{ $t("message.已下架") }}</el-radio>
              <el-radio :label="2">{{ $t("message.不显示") }}</el-radio>
              <el-radio :label="3">{{ $t("message.测试用") }}</el-radio>

            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.推荐标识") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="isrecommend">
              <el-radio :label="'0'">{{ $t("message.否") }}</el-radio>
              <el-radio :label="'1'">{{ $t("message.是") }}</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.类型") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="belong">
              <el-radio :label="0">{{ $t("message.普通") }}</el-radio>
              <el-radio :label="1">{{ $t("message.积分商城商品") }}</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr v-if="shelvesid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.搜索次数") }}</span>
          </td>
          <td>
            <el-input v-model="searchcount" readonly size="mini" placeholder="">
              <!-- <template slot="prepend">详情类型ID</template> -->
            </el-input>
          </td>
        </tr>
        <tr v-if="shelvesid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.浏览次数") }}</span>
          </td>
          <td>
            <el-input v-model="viewcount" readonly size="mini" placeholder="">
              <!-- <template slot="prepend">详情类型ID</template> -->
            </el-input>
          </td>
        </tr>
        <tr v-if="shelvesid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.创建日期") }}</span>
          </td>
          <td>
            <el-input
              readonly
              v-model="createdate"
              size="mini"
              placeholder=""
            />
          </td>
        </tr>
        <tr v-if="shelvesid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.创建人") }}</span>
          </td>
          <td>
            <el-input readonly size="mini" :placeholder="idtoname(createid)" />
          </td>
        </tr>
        <tr v-if="shelvesid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.更新日期") }}</span>
          </td>
          <td>
            <el-input readonly v-model="editdate" size="mini" placeholder="" />
          </td>
        </tr>
        <tr v-if="shelvesid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.更新人") }}</span>
          </td>
          <td>
            <el-input readonly size="mini" :placeholder="idtoname(editid)" />
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.上市发布时间") }}</span>
          </td>
          <td>
            <el-date-picker
              v-model="onshelves"
              align="right"
              type="date"
              :disabled="!isEditMode"
              placeholder="选择日期">
            </el-date-picker>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.兑换开始时间") }}</span>
          </td>
          <td>
            <el-date-picker
              v-model="preonsaledate"
              align="right"
              type="datetime"
              :disabled="!isEditMode"
              placeholder="选择日期">
            </el-date-picker>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.兑换结束时间") }}</span>
          </td>
          <td>
            <el-date-picker
              v-model="preoffsaledate"
              align="right"
              type="datetime"
              :disabled="!isEditMode"
              placeholder="选择日期">
            </el-date-picker>
          </td>
        </tr>

        <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.购买所需最小等级") }}</span>
            </td>
            <td>
              <el-select size="small" v-model="buyrolelv" :placeholder="$t('message.请选择')" :disabled="!isEditMode" clearable>
                    <el-option
                      v-for="item in typeGrade"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
            </td>
          </tr>

          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.查看所需最小等级") }}</span>
            </td>
            <td>
              <el-select size="small" v-model="viewrolelv" :placeholder="$t('message.请选择')" :disabled="!isEditMode" clearable>
                    <el-option
                      v-for="item in typeGrade"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
            </td>
          </tr>

          <tr>
              <!-- <td style="padding-left: 20px"> -->
              <td>
                  <span class="simpleLabel">邮费积分组</span>
              </td>
              <td>
                  <el-select :disabled="!isEditMode" size="small" v-model="postagepointgp"
                      :placeholder="$t('message.请选择')" clearable>
                      <el-option v-for="item in pointgrouplists" :key="item.groupid" :label="item.name"
                          :value="item.groupid" :disabled="item.disabled">
                      </el-option>
                  </el-select>
              </td>
          </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.邮费积分") }}</span>
          </td>
          <td>
            <el-input-number
                :min="0"
                :disabled="!isEditMode"
                size="mini"
                v-model="postagepoints"
              ></el-input-number>
          </td>
        </tr>

        <!-- <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.核销过期类型") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="writeoffvaliditytype">
              <el-radio :label="1" >{{ $t("message.永久有效") }}</el-radio>
              <el-radio :label="2" >{{ $t("message.固定时间") }}</el-radio>
              <el-radio :label="3" >{{ $t("message.领取后有效时间") }}</el-radio>
            </el-radio-group>
          </td>
        </tr> -->
        <tr v-if="this.writeoffvaliditytype==2">
          <td>
            <span class="simpleLabel">{{ $t("message.核销有效时间") }}</span>
          </td>
          <td>
            <el-date-picker
              v-model="expiryDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </td>
        </tr>
        <tr v-if="this.writeoffvaliditytype==3">
          <td>
            <span class="simpleLabel">{{ $t("message.领取后有效天数") }}</span>
          </td>
          <td>
            <el-input-number
                :min="0"
                :disabled="!isEditMode"
                size="mini"
                v-model="writeoffValidityDay"
              ></el-input-number>
          </td>
        </tr>
        <!-- <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.逾期能否核销") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="writeoffoverdue">
              <el-radio :label="0" >{{ $t("message.逾期后不可核销") }}</el-radio>
              <el-radio :label="1" >{{ $t("message.逾期后可核销") }}</el-radio>
            </el-radio-group>
          </td>
        </tr> -->
      </table>
    </div>
    <div class="grid-content subtitle">
      <span>2.货架轮播图</span>
    </div>
    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button
            :disabled="!isEditMode"
            size="medium"
            round
            @click.native="createTarget"
          >
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.添加") }}
          </el-button>
        </el-link>
      </div>
    </div>
    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        border
        :max-height="tableHeight"
        style="width: 100%"
        :key="tableDataKey"
      >
        <el-table-column fixed label="No." type="index" width="55">
        </el-table-column>
        <el-table-column
          fixed
          width="160"
          :label="$t('message.操作')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                v-if="!isEditMode"
                round
                type="normal"
                icon="el-icon-zoom-in"
                @click="editTarget(scope.row, false)"
              ></el-button>
              <el-button
                size="mini"
                v-else
                round
                type="normal"
                icon="el-icon-edit"
                @click="editTarget(scope.row, true)"
              ></el-button>
              <el-button
                size="mini"
                :disabled="!isEditMode"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  targetRow = scope.row;
                  deleteDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column
          label="轮播图片750*min（510）"
          width="250"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.img != ''"
              placement="top-start"
              title=""
              trigger="hover"
            >
              <img
                :src="'' + scope.row.img"
                alt=""
                style="max-width: 500px; max-height: 500px"
              />
              <img
                slot="reference"
                :src="'' + scope.row.img"
                style="max-width: 120px; max-height: 30px"
              />
            </el-popover>
            <span v-else>{{ $t("message.无") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="sort"
          :label="$t('message.排序')"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          sortable
          :label="$t('message.是否列表显示')"
          min-width="150"
        >
          <template slot-scope="scope">
            <span>{{ getBooleanName(scope.row.isshow) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="grid-content subtitle">
      <span>3.货架海报图</span>
    </div>
    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button
            :disabled="!isEditMode"
            size="medium"
            round
            @click.native="createPoster"
          >
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.添加") }}
          </el-button>
        </el-link>
        <el-link :underline="false">
          <el-button size="medium" round @click.native="onPreview">
            <i class="el-icon-view"></i>
            预览
          </el-button>
        </el-link>
      </div>
    </div>
    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="posterData"
        stripe
        border
        :max-height="tableHeight"
        style="width: 100%"
        :key="posterTableKey"
      >
        <el-table-column fixed label="No." type="index" width="55">
        </el-table-column>
        <el-table-column
          fixed
          width="160"
          :label="$t('message.操作')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                v-if="!isEditMode"
                round
                type="normal"
                icon="el-icon-zoom-in"
                @click="editPoster(scope.row, false)"
              ></el-button>
              <el-button
                size="mini"
                v-else
                round
                type="normal"
                icon="el-icon-edit"
                @click="editPoster(scope.row, true)"
              ></el-button>
              <el-button
                size="mini"
                :disabled="!isEditMode"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  posterRow = scope.row;
                  deletePosterDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column
          label="海报图片700*min（any）"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.img != ''"
              placement="top-start"
              title=""
              trigger="hover"
            >
              <img
                :src="'' + scope.row.img"
                alt=""
                style="max-width: 500px; max-height: 500px"
              />
              <img
                slot="reference"
                :src="'' + scope.row.img"
                style="max-width: 120px; max-height: 30px"
              />
            </el-popover>
            <span v-else>{{ $t("message.无") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="sort"
          :label="$t('message.排序')"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          sortable
          :label="$t('message.是否列表显示')"
          min-width="150"
        >
          <template slot-scope="scope">
            <span>{{ getBooleanName(scope.row.isshow) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="grid-content subtitle">
      <span>4.货架视频</span>
    </div>
    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button
            :disabled="!isEditMode"
            size="medium"
            round
            @click.native="createVideo"
          >
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.添加") }}
          </el-button>
        </el-link>
      </div>
    </div>
    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="videoData"
        stripe
        border
        :max-height="tableHeight"
        style="width: 100%"
        :key="videoTableKey"
      >
        <el-table-column fixed label="No." type="index" width="55">
        </el-table-column>
        <el-table-column
          fixed
          width="160"
          :label="$t('message.操作')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                v-if="!isEditMode"
                round
                type="normal"
                icon="el-icon-zoom-in"
                @click="editVideo(scope.row, false)"
              ></el-button>
              <el-button
                size="mini"
                v-else
                round
                type="normal"
                icon="el-icon-edit"
                @click="editVideo(scope.row, true)"
              ></el-button>
              <el-button
                size="mini"
                :disabled="!isEditMode"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  videoRow = scope.row;
                  deleteVideoDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column label="封面图片" width="150" align="center">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.cover != ''"
              placement="top-start"
              title=""
              trigger="hover"
            >
              <img
                :src="'' + scope.row.cover"
                alt=""
                style="max-width: 500px; max-height: 500px"
              />
              <img
                slot="reference"
                :src="'' + scope.row.cover"
                style="max-width: 120px; max-height: 30px"
              />
            </el-popover>
            <span v-else>{{ $t("message.无") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="channelsid"
          label="视频号id"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="programid"
          label="节目id"
          min-width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="sort"
          :label="$t('message.排序')"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          sortable
          :label="$t('message.是否列表显示')"
          min-width="150"
        >
          <template slot-scope="scope">
            <span>{{ getBooleanName(scope.row.isshow) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

<div class="grid-content subtitle">
      <span>5.货品</span>
 </div>
 <div class="grid-content content-margin">
  <goodsSelection :isModify='editStatus.isModify' :tableData.sync='commoditys'></goodsSelection>
  </div>



  
    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除该内容") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteTarget">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deletePosterDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除该内容") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deletePosterDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deletePoster">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 视频删除框 -->
    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteVideoDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除该内容") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVideoDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteVideo">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>

    <el-drawer
      :show-close="false"
      :size="800"
      :visible.sync="showDateilDrawer"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>{{ $t("message.轮播图管理sel") }}</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="showDateilDrawer = false"
            >
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSaveDetail">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.确定") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.图片") }}</span>
            </td>
            <td>
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(2)">
                <i class="iconfont" v-if="!d_img">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img
                    :src="'' + d_img"
                    alt=""
                    style="max-width: 500px; max-height: 500px"
                  />
                  <img slot="reference" :src="'' + d_img" />
                  <el-button
                    v-if="isEditMode"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click.native="d_img = ''"
                  ></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.是否显示") }}</span>
            </td>
            <td>
              <el-switch
                :disabled="!isEditMode"
                v-model="d_isShowSwitch"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"
              ></el-switch>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.优先级排序") }}</span>
            </td>
            <td>
              <el-input-number
                :min="0"
                :disabled="!isEditMode"
                size="mini"
                v-model="d_sort"
              ></el-input-number>
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>

    <el-drawer
      :show-close="false"
      :size="800"
      :visible.sync="showPosterDateilDrawer"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>海报图管理</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="showPosterDateilDrawer = false"
            >
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSavePosterDetail">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.确定") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.图片") }}</span>
            </td>
            <td>
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(3)">
                <i class="iconfont" v-if="!posterImg">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img
                    :src="'' + posterImg"
                    alt=""
                    style="max-width: 500px; max-height: 500px"
                  />
                  <img slot="reference" :src="'' + posterImg" />
                  <el-button
                    v-if="isEditMode"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click.native="posterImg = ''"
                  ></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.是否显示") }}</span>
            </td>
            <td>
              <el-switch
                :disabled="!isEditMode"
                v-model="posterIsShowSwitch"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"
              ></el-switch>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.优先级排序") }}</span>
            </td>
            <td>
              <el-input-number
                :min="0"
                :disabled="!isEditMode"
                size="mini"
                v-model="posterSort"
              ></el-input-number>
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>

    <!-- 视频管理 -->
    <el-drawer
      :show-close="false"
      :size="800"
      :visible.sync="showVideoDateilDrawer"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>视频管理（封面图和视频大小700*min（440））</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="showVideoDateilDrawer = false"
            >
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSaveVideoDetail">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.确定") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">视频</span>
            </td>
            <td>
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(4)">
                <i class="iconfont" v-if="!videoUrl">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <video
                    width="480"
                    height="320"
                    controls
                    :src="videoUrl"
                    type="video/mp4"
                  >
                    <!-- <source :src="videoUrl" type="video/mp4"> -->
                    您的浏览器不支持 HTML5 video 标签。
                  </video>

                  <img
                    slot="reference"
                    :src="'../../../static/images/mp4.png'"
                  />
                  <el-button
                    v-if="isEditMode"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click.native="videoUrl = ''"
                  ></el-button>
                </el-popover>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <span class="simpleLabel">封面图</span>
            </td>
            <td>
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(5)">
                <i class="iconfont" v-if="!videoCover">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img
                    :src="'' + videoCover"
                    alt=""
                    style="max-width: 500px; max-height: 500px"
                  />
                  <img slot="reference" :src="'' + videoCover" />
                  <el-button
                    v-if="isEditMode"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click.native="videoCover = ''"
                  ></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">视频号id</span>
            </td>
            <td>
              <el-input
                size="mini"
                placeholder="视频号id"
                v-model="channelsid"
                :disabled="!isEditMode"
              />
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">节目id</span>
            </td>
            <td>
              <el-input
                size="mini"
                placeholder="节目id"
                v-model="programid"
                :disabled="!isEditMode"
              />
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.是否显示") }}</span>
            </td>
            <td>
              <el-switch
                :disabled="!isEditMode"
                v-model="videoIsShowSwitch"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"
              ></el-switch>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.优先级排序") }}</span>
            </td>
            <td>
              <el-input-number
                :min="0"
                :disabled="!isEditMode"
                size="mini"
                v-model="videoSort"
              ></el-input-number>
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>

    <shade v-if="showResourceStore > 0">
      <resource-store
        :shadeShow="showResourceStore > 0"
        @onClick="onResourceStoreCallback"
        :appID="appid"
      ></resource-store>
    </shade>
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import { topfixfunc } from "@/utils/topFix";
import ResourceStore from "@/components/resourceStore/resourceStore";
import shade from "@/components/shade/shade";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import { pushdata, idtoname } from "@/utils/minxins";
import goodsSelection from "@/components/elementSelect/goodsSelection";

export default {
  name: "productDetail",
  components: {
    shade,
    ResourceStore,
    goodsSelection,
  },
  data() {
    return {
    editStatus:{
                // 创建模式
                isCreate:true,
                // 是否可编辑
                isModify:true
            },
            tableData:[],
      tableHeight: 500,
      appid: 0,
      shelvesid: 0,
      name: "",
      name2: "",
      brandid: "",
      typeOptions: [
        {
          value: "0",
          label: "加载中..",
          disabled: true,
        },
      ],
      img: "",
      shelvesinfo: "",
      jumpurl: "",
      state: 0,
      isrecommend: "0",
      belong:0,
      onshelves:"",
      preonsaledate:"",
      preoffsaledate:"",
      postagepoints:0, // 邮费积分
      postagepointgp:'', // 邮费积分组
      pointgrouplists:[],
      viewrolelv:null,   // 查看所需会员等级
      buyrolelv:null,    // 购买所需会员等级
      writeoffvaliditytype:0,
      writeoffValidityDay:0,
      expiryDate:[],
      writeoffoverdue:0,
      searchcount: 0,
      viewcount: 0,
      createdate: "",
      createid: "",
      idtoname: idtoname,
      editdate: "",
      editid: "",
      isEditMode: true,
      isInit: true,
      showResourceStore: false,
      deleteDialogVisible: false,
      showDateilDrawer: false,
      d_img: "",
      d_jumpurl: "",
      d_isShowSwitch: true,
      d_sort: 0,
      tableData: [],
      targetRow: null,
      tableDataKey:0,

      //货架海报编辑数据
      showPosterDateilDrawer: false,
      posterData: [],
      posterRow: null,
      posterImg: "",
      posterJumpUrl: "",
      posterIsShowSwitch: true,
      posterSort: 0,
      deletePosterDialogVisible: false,
      posterTableKey:0,

      //货架视频编辑数据
      showVideoDateilDrawer: false,
      videoData: [],
      videoRow: null,
      videoUrl: "",
      videoCover: "",
      videoIsShowSwitch: true,
      channelsid: "",
      programid: "",
      videoSort: 0,
      deleteVideoDialogVisible: false,
      videoTableKey:0,
      multiselect:[],

      //货品编辑数据
      commoditys:[],

             
      typeGrade: [
         
        ],
    };
  },
  mounted: function () {
    // 用来监听el-main滚动事件
    topfixfunc();
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {
  writeoffvaliditytype(newValue, oldValue){
      console.log('监听数据变化',newValue,oldValue)
      this.writeoffvaliditytype = newValue;
      console.log('看点击后',this.writeoffvaliditytype)

},
  },
  methods: {
    // 监听滚动事件

    doShowResourceStore(type) {
      if (!this.isEditMode) return;
      this.showResourceStore = type;
    },
    onResourceStoreCallback(doc) {
      console.log(doc);
      if (doc) {
        switch (this.showResourceStore) {
          case 1:
            this.img = doc.resourceID;
            break;
          case 2:
            this.d_img = doc.resourceID;
            break;
          case 3:
            this.posterImg = doc.resourceID;
            this.multiselect=doc.multiselect
            // console.log(doc)
            break;
          case 4:
            this.videoUrl = doc.resourceID;
            break;
          case 5:
            this.videoCover = doc.resourceID;
        }
        this.showResourceStore = 0;
      } else {
        this.showResourceStore = 0;
      }
    },
    goBack() {
      this.$router.go(-1); //返回上一层
    },
    //获取角色管理
    getrolelist(){
      rejecthttp(
          false,
          "get",
          "/manage/user/getrolelist",
          {
            appid: 188,
          },
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              console.log('查看角色',doc.data)
              doc.data.data.forEach(item=>{
                this.typeGrade.push({
                  value:item.level,
                  label:item.name
                })
              })
              // this.typeGrade = 
            }
          }
        );
    },
    modify(){
      this.isEditMode = true;
      this.editStatus.isModify= true;

    },
    doSave() {
      if (this.name.trim() == "") {
        this.$message({
          type: "error",
          message: this.$t("message.货架名称不能为空"),
        });
        return;
      }
      this.isEditMode = false;
      this.editStatus.isModify= false;

      let sendObj = {
        appid: this.appid,
        info: {
          appid: this.appid,
          shelvesid: this.shelvesid,
          name: this.name.trim(),
          name2: this.name2.trim(),
          belong: this.belong,
          brandid: this.brandid,
          img: this.img,
          shelvesinfo: this.shelvesinfo,
          jumpurl: this.jumpurl,
          state: this.state,
          isrecommend: this.isrecommend,
          onshelves:this.onshelves,
          preonsaledate:this.preonsaledate,
          preoffsaledate:this.preoffsaledate,
          postagepoints:this.postagepoints,
          postagepointgp:this.postagepointgp,
          buyrolelv:this.buyrolelv,
          viewrolelv:this.viewrolelv,
          writeoffvaliditytype:this.writeoffvaliditytype,
          writeoffValidityDay:this.writeoffValidityDay,
          expiryDateBegin:this.expiryDate[0],
          expiryDateEnd:this.expiryDate[1],
          writeoffoverdue:this.writeoffoverdue,
          createdate: "2021-07-21T07:17:22.619Z",
          createid: 0,
          editdate: "2021-07-21T07:17:22.619Z",
          editid: 0,
        },
        carousels: this.tableData,
        posters: this.posterData,
        videos: this.videoData,
        commoditys:this.commoditys,
      };
      if (this.isInit)
        rejecthttp(
          true,
          "post",
          "/manage/product/addshelves",
          sendObj,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
              // console.log(doc.data);
              // this.pageConfig.total=doc.data.exData.datas
              // this.tableData = doc.data.data;
              // this.tableData.forEach((any) => {
              //   any.editdate = commonUtil.formatDate(any.editdate);
              // });
            }
          }
        );
      // this.$http
      //   .post("/manage/product/addshelves", sendObj)
      //   .then((doc) => {
      //     // console.log(doc.data)
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.$message({
      //         type: "success",
      //         message: doc.data.Message,
      //       });
      //       this.$router.go(-1); //返回上一层
      //     }
      //   });
      else {
        rejecthttp(
          true,
          "post",
          "/manage/product/updateshelves",
          sendObj,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
            }
          }
        );
        // this.$http
        //   .post("/manage/product/updateshelves", sendObj)
        //   .then((doc) => {
        //     // console.log(doc.data)
        //     if (doc.data.Code != "MSGKEY_OK") {
        //       this.$message({
        //         type: "error",
        //         message: doc.data.Message,
        //       });
        //     } else {
        //       this.$message({
        //         type: "success",
        //         message: doc.data.Message,
        //       });
        //     }
        //   });
      }
    },
    doSaveDetail() {
      if (this.targetRow) {
        this.targetRow.img = this.d_img;
        this.targetRow.jumpurl = this.d_jumpurl;
        this.targetRow.isshow = this.d_isShowSwitch ? 1 : 0;
        this.targetRow.sort = this.d_sort;
      } else {
        let item = {
          img: this.d_img,
          jumpurl: this.d_jumpurl,
          isshow: this.d_isShowSwitch ? 1 : 0,
          sort: this.d_sort,
        };
        console.log(this.tableData)
        this.tableData.push(item);
      }
      this.sortTableData();
      this.showDateilDrawer = false;
    },
    doSavePosterDetail() {
      if (this.posterRow) {
        this.posterRow.img = this.posterImg;
        this.posterRow.jumpurl = this.posterJumpUrl;
        this.posterRow.isshow = this.posterIsShowSwitch ? 1 : 0;
        this.posterRow.sort = this.posterSort;
      } else {
        // let item = {
        //   img: this.posterImg,
        //   jumpurl: this.posterJumpUrl,
        //   isshow: this.posterIsShowSwitch ? 1 : 0,
        //   sort: this.posterSort,
        // };
        for(let i =0 ;i<this.multiselect.length;i++){
          let item={
            img: this.multiselect[i].url,
          jumpurl: this.posterJumpUrl,
          isshow: this.posterIsShowSwitch ? 1 : 0,
          sort: this.posterSort,
          }
        this.posterData.push(item);

        }
      }
      this.sortPoster();
      this.showPosterDateilDrawer = false;
    },

    doSaveVideoDetail() {
      if (this.videoRow) {
        this.videoRow.video = this.videoUrl;
        this.videoRow.cover = this.videoCover;
        this.videoRow.isshow = this.videoIsShowSwitch ? 1 : 0;
        this.videoRow.channelsid = this.channelsid;
        this.videoRow.programid = this.programid;
        this.videoRow.sort = this.videoSort;

        console.log(this.videoData);
      } else {
        let item = {
          video: this.videoUrl,
          cover: this.videoCover,
          isshow: this.videoIsShowSwitch ? 1 : 0,
          channelsid: this.channelsid,
          programid: this.programid,
          sort: this.videoSort,
        };
        this.videoData.push(item);
      }
      this.sortVedio();
      this.showVideoDateilDrawer = false;
    },

    refresh() {
      //获取货品详细信息
      rejecthttp(
          false,
          "get",
          "/manage/point/pointgrouplist",
            { appid: "188", search: "" },
          this,
          (doc) => {
              if (doc.data.Code != "MSGKEY_OK") {
              } else {
                  // this.$message({
                  // type: "success",
                  // message:"获取积分组接口成功"
                  //  });
                  console.log(doc.data.data[0].name)
                  this.pointgrouplists = doc.data.data
                  console.log(this.pointgrouplists)
              }
          }
      );

      this.$http
        .get("/manage/brand/getbrandlist", {
          params: {
            appid: "188",
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            console.log(doc.data);
            this.typeOptions = [];
            doc.data.data.forEach((any) => {
              let item = {
                value: any.brandid,
                label: any.name,
              };
              this.typeOptions.push(item);
            });
          }
        });
      if (!this.shelvesid) {
        return;
      }
      this.$http
        .get("/manage/product/getproductinfo", {
          params: {
            appid: this.appid,
            productid: this.shelvesid,
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            console.log(doc.data);
            pushdata(doc.data.exData.datas);
            this.commoditys = doc.data.data.commoditys;
            this.shelvesid = doc.data.data.info.shelvesid;
            this.name = doc.data.data.info.name;
            this.name2 = doc.data.data.info.name2;
            this.brandid = doc.data.data.info.brandid;
            this.img = doc.data.data.info.img;
            this.shelvesinfo = doc.data.data.info.shelvesinfo;
            this.jumpurl = doc.data.data.info.jumpurl;
            this.belong = doc.data.data.info.belong;
            this.state = doc.data.data.info.state;
            this.isrecommend = doc.data.data.info.isrecommend.toString();
            this.onshelves=doc.data.data.info.onshelves;
            this.preonsaledate=doc.data.data.info.preonsaledate;
            this.preoffsaledate=doc.data.data.info.preoffsaledate;
            this.postagepoints=doc.data.data.info.postagepoints;
            this.postagepointgp=doc.data.data.info.postagepointgp;
            this.buyrolelv=doc.data.data.info.buyrolelv;
            this.viewrolelv=doc.data.data.info.viewrolelv;
            this.writeoffvaliditytype	=doc.data.data.info.writeoffvaliditytype;
            this.writeoffValidityDay=doc.data.data.info.writeoffValidityDay;
            this.expiryDate[0]=doc.data.data.info.expiryDateBegin;
            this.expiryDate[1]=doc.data.data.info.expiryDateEnd;
            this.writeoffoverdue=doc.data.data.info.writeoffoverdue;
            this.searchcount = doc.data.data.info.searchcount;
            this.viewcount = doc.data.data.info.viewcount;
            this.createdate = commonUtil.formatDate(
              doc.data.data.info.createdate
            );
            this.createid = doc.data.data.info.createid;
            this.editdate = commonUtil.formatDate(doc.data.data.info.editdate);
            this.editid = doc.data.data.info.editid;
            this.tableData = doc.data.data.carousels?doc.data.data.carousels:[];
            this.sortTableData();
            if (doc.data.data.posters != null) {
              this.posterData = doc.data.data.posters;
              this.sortPoster();
            }
            if (doc.data.data.videos != null) {
              this.videoData = doc.data.data.videos;
              this.sortVedio();
            }
            if (!this.tableData) this.tableData = [];
          }
        });
    },
    getBooleanName(bool) {
      return commonUtil.getBooleanName(bool);
    },
    createTarget() {
      //清空值
      this.targetRow = null;
      this.d_img = "";
      this.d_jumpurl = "";
      this.d_isShowSwitch = true;
      this.d_sort = 0;

      this.showDateilDrawer = true;
    },
    createPoster() {
      this.posterRow = null;
      this.posterImg = "";
      this.posterJumpUrl = "";

      this.posterIsShowSwitch = true;
      this.posterSort = 0;

      this.showPosterDateilDrawer = true;
    },

    createVideo() {
      this.videoRow = null;
      this.videoUrl = "";
      this.videoCover = "";
      this.channelsid = "";
      this.programid = "";
      this.videoIsShowSwitch = true;
      this.videoSort = 0;

      this.showVideoDateilDrawer = true;
    },

    editTarget(data, edit) {
      this.targetRow = data;
      //赋值
      this.d_img = this.targetRow.img;
      this.d_jumpurl = this.targetRow.jumpurl;
      this.d_isShowSwitch = this.targetRow.isshow == 1 ? true : false;
      this.d_sort = this.targetRow.sort;
      this.showDateilDrawer = true;
    },
    editPoster(data, edit) {
      this.posterRow = data;
      //赋值
      this.posterImg = this.posterRow.img;
      this.posterJumpUrl = this.posterRow.jumpurl;
      this.posterIsShowSwitch = this.posterRow.isshow == 1 ? true : false;
      this.posterSort = this.posterRow.sort;
      this.showPosterDateilDrawer = true;
    },

    editVideo(data, edit) {
      console.log("editVideo", this.videoData);
      this.videoRow = data;
      //赋值
      this.channelsid = this.videoRow.channelsid;
      this.programid = this.videoRow.programid;
      this.videoUrl = this.videoRow.video;
      console.log("aaaaaaaa", this.videoUrl);
      this.videoCover = this.videoRow.cover;
      this.videoIsShowSwitch = this.videoRow.isshow == 1 ? true : false;
      this.videoSort = this.videoRow.sort;
      this.showVideoDateilDrawer = true;
    },

    deleteTarget() {
      console.log(this.targetRow);
      let index = this.tableData.findIndex((item) => {
        if (item == this.targetRow) {
          return true;
        }
      });
      this.tableData.splice(index, 1);
      this.deleteDialogVisible = false;
    },

    deletePoster() {
      console.log(this.posterRow);
      let index = this.posterData.findIndex((item) => {
        if (item == this.posterRow) {
          return true;
        }
      });
      this.posterData.splice(index, 1);
      this.deletePosterDialogVisible = false;
    },

    deleteVideo() {
      console.log(this.videoRow);
      let index = this.videoData.findIndex((item) => {
        if (item == this.videoRow) {
          return true;
        }
      });
      this.videoData.splice(index, 1);
      this.deleteVideoDialogVisible = false;
    },

    onPreview() {
      let routeUrl = this.$router.resolve({
        path: "/ProductPosterPreview",
        query: {
          appid: this.appid,
          shelvesid: this.shelvesid,
          posters: JSON.stringify(this.posterData),
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },

    sortPoster() {
      this.posterData.sort(commonUtil.sortAsc, "sort");
      this.posterTableKey++;
    },

    sortVedio() {
      this.videoData.sort(commonUtil.sortAsc, "sort");
      this.videoTableKey++;
    },

    sortTableData() {
      this.tableData.sort(commonUtil.sortAsc, "sort");
      this.tableDataKey++;
    },
  },
  created() {
    this.appid = this.$route.query.appid ? this.$route.query.appid : 0;
    if (this.$route.query.id) {
      this.shelvesid = this.$route.query.id;
      this.isEditMode = this.$route.query.isEditMode ? true : false;
      this.isInit = false;
    }
    this.refresh();
    this.getrolelist()

  },
  computed: {},
  // // 隐藏固定栏
  // destroyed () {
  //   var topFix=document.querySelector('.topFix')
  //   // 固定栏隐藏
  //   topFix.style.display='none'
  // }
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/ProductDetail.vue